import call from "@/conn-global/api";

export default {
  postHistory: async ({ commit }, data) => {
    return call
      .post("/v1/transaksi/list_history", data)
      .then((res) => {
        // console.log("Request Data:", data);
        // console.log("Response Data:", res.data.data.history_data);
        commit("historyLayanan", res.data.data);
        commit("setNextPagination", res.data.data);
        return res.data;
      })
      .catch((err) => {
        throw err;
      });
  },

  getDetailSnap: async ({ commit }, id) => {
		commit("setLoadingDetail", true);
    await call
      .get("/v1/transaksi/get_detail_snap_transaksi/" + id, true)
      .then((res) => {
        if (res != undefined) {
          commit("setDetailSnapTransaksi", res.data.data);
        }
      })
      .catch((err) => {
        throw err;
			}).finally(() => {
				commit("setLoadingDetail", false);
			});
  },
  getDetailTopUp: async ({ commit }, id) => {
		commit("setLoadingDetail", true);
    let response = await call
      .get("/v1/epayment/get_epayment/" + id, true)
      .then((res) => {
        if (res != undefined) {
          commit("setDetailTopUp", res.data.data);
          return res;
        }
        return res;
      })
      .catch((err) => {
        throw err;
			}).finally(() => {
				commit("setLoadingDetail", false);
			});
    return response;
  },
	getDetailSnapHapus: async ({ commit }, id) => {
		commit("setLoadingDetail", true);
    await call
      .get("/v1/transaksi/get_detail_snap_hapus/" + id, true)
      .then((res) => {
        if (res != undefined) {
          commit("setDetailSnapTransaksi", {...res.data.data, isDelete: true});
        }
      })
      .catch((err) => {
        throw err;
			}).finally(() => {
				commit("setLoadingDetail", false);
			});
  },
	getDetailRefund: async ({ commit }, id) => {
		commit("setLoadingDetail", true);
    let response = await call
      .get("/v1/epayment/get_detail_refund/" + id, true)
      .then((res) => {
        if (res != undefined) {
          commit("setDetailRefund", res.data.data);
          return res;
        }
        return res;
      })
      .catch((err) => {
        throw err;
			}).finally(() => {
				commit("setLoadingDetail", false);
			});
    return response;
  },
};

// // try {
//   let response = await call.post("/v1/transaksi/list_history", data);

//   console.log("Request Data:", data);
//   console.log("Response Data:", response.data.data.history_data);
//   commit("historyLayanan", response.data.data);
//   commit("setNextPagination", response.data.data);
//   return response;
// } catch (error) {
//   console.log("API Error:", error);
//   return error.response;
// }
